<template>
    <div class="bookConfig-edit app-container">
        <div class="bookConfig-edit-header bg-white">
            <div class="bookConfig-edit-header-left">
                <span>超星集团</span>
                <span>FID：1385</span>
            </div>
            <div class="bookConfig-edit-header-right">
                <button class="global-button-style" @click="toAdd">{{$t('commonMsg.new')}}</button>
            </div>
        </div>
        <el-card class="app-table-container" :body-style="{ padding: '20px' }">
            <div slot="header">
                <span><!-- card title --></span>
            </div>
            <div class="global-body-wrap">
                <appTable :tableData = "tableData" :tableProps = "tableProps"/>
            </div>
            <pagination
            :pageSize="params.limit"
            :total = "total"
            @pageNum="getPageNum"
            />
        </el-card>
    </div>
        
</template>

<script>
import appTable from '@/components/appTable'
import pagination from '@/components/pagination'
import listMixin from '@/mixins/list'
export default {
    components: {
        appTable,
        pagination
    },
    computed: {
        tableProps() {
            let  tableProps = [{
                prop: 'library',
                label: this.$t('org.library')
            }, {
                prop: 'address',
                label: this.$t('org.address')
            }, {
                prop: 'move',
                label: this.$t('commonMsg.move')
            }, {
                prop: 'handle',
                label: this.$t('org.manage'),
                btn: [this.$t('commonMsg.del')]
            }]
            
            return tableProps
        }
    },
    mixins:[listMixin],
    data() {
        return {
            params: {
                limit: 20,
                offset: 0
            },
            tableData: [{
                library: '校园阅读系统',
                address: 'list.html?isBackToFirstBtn=y',
            }, {
                library: '家长学校',
                address: 'list.html?isBackToFirstBtn=y',
            }, {
                library: '心理健康平台',
                address: 'list.html?isBackToFirstBtn=y',
            }],
            total: 0
        }
    },
    
    methods: {
        getList() {

        },
        toAdd() {
            this.$router.push({name: 'bookConfigAdd'})
        }
    }
}
</script>

<style lang="scss" scoped>
    .bookConfig-edit-header{
        padding:10px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .bookConfig-edit-header-left{
            >span{
                margin-right:10px;
            }
        }
    }
</style>

